var version = {
    "name":      "dativery",
    "buildDateCode": "20251215-092524",
    "buildDate": "Mon Dec 15 2025 09:25:24 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251215-092524",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;